import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "請求者情報を登録してください",
  },
  {
    title: "請求者名",
    keyword: "demanderNameKanji",
    type: "name",
    requiredIcon: true,
  },
  {
    title: "請求者名（フリガナ）",
    keyword: "demanderNameKana",
    type: "name",
    convertToHalfwidth: true,
    requiredIcon: true,
    useFurigana: true,
    hafWidth: true,
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "date",
    requiredIcon: true,
    maxDate: new Date(),
    minDate: new Date("1900/01/01"),
  },
  {
    title: `電話番号`,
    keyword: "demanderPhoneNumber",
    type: "phoneNum",
    requiredIcon: true,
    inputProps: { maxLength: 21 },
  },
  {
    title: `メールアドレス（機構連絡用）`,
    keyword: "email",
    type: "mail",
    requiredIcon: true,
    inputProps: [{ minLength: 1 }, { maxLength: 255 }],
  },
  {
    title: `メールアドレス（機構連絡用）（確認用）`,
    keyword: "email2",
    type: "mail",
    requiredIcon: true,
    inputProps: [{ minLength: 1 }, { maxLength: 255 }],
  },
];
const schema = {
  demanderNameKanji: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  demanderNameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  birthday: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  email: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
  },
  email2: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
  },
  demanderPhoneNumber: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
};
export { fakeTableList, schema };
